module.exports = __webpack_public_path__ + "media/images/price-increase-ee6a6fe2786fd405b1c82882e6a0dbfb.png";